
const Footer = () => {
  
    return (
      <div className="footer_content">
            <p>Theme - me.xatgif.com</p>
            <span>&copy; 2022 - JasonOficial - 1202</span>
      </div>
    )
}

export default Footer
